document.addEventListener('DOMContentLoaded', function () {
  const mainContent = document.querySelector('#MainContent');
  const productHTML = `
    <div class="cw-product-card" style="display: block;">
      <div class="cw-price-section"></div>
      <div class="cw-cart-section">
        <div class="cw-quantity-selector">
          <button class="cw-qty-btn">-</button>
          <span class="cw-qty-value">1</span>
          <button class="cw-qty-btn">+</button>
        </div>
        <button class="cw-add-to-cart">ADD TO CART</button>
      </div>
    </div>
  `;
  if (mainContent && mainContent.parentNode) {
    mainContent.insertAdjacentHTML('afterend', productHTML);
  }

  const productInfo = document.querySelector('.product__info-container');
  const stickyATC = document.querySelector('.cw-product-card');
  if (!productInfo || !stickyATC) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (window.innerWidth <= 768) {
        stickyATC.style.display = entry.isIntersecting ? 'none' : 'block';
      }
    });
  }, { threshold: 0 });
  observer.observe(productInfo);

  const customCard = document.querySelector('.cw-product-card');
  const shopifyQtyInput = document.querySelector('.quantity__input');
  const customQtyDisplay = customCard?.querySelector('.cw-qty-value');
  const customMinus = customCard?.querySelector('.cw-qty-btn:first-child');
  const customPlus = customCard?.querySelector('.cw-qty-btn:last-child');
  const shopifyMinus = document.querySelector('button[name="minus"]');
  const shopifyPlus = document.querySelector('button[name="plus"]');
  const customATC = customCard?.querySelector('.cw-add-to-cart');
  const shopifyATC = document.querySelector('.product-form__submit-main');

  function syncQty(value = 1) {
    value = Math.max(1, value);
    if (customQtyDisplay) customQtyDisplay.textContent = value;
    if (shopifyQtyInput) shopifyQtyInput.value = value;
    const disable = value === 1;
    [customMinus, shopifyMinus].forEach(btn => {
      if (btn) {
        btn.classList.toggle('disabled', disable);
        btn.style.pointerEvents = disable ? 'none' : 'auto';
      }
    });
  }

  customPlus?.addEventListener('click', () => {
    syncQty(parseInt(customQtyDisplay.textContent, 10) + 1);
  });
  customMinus?.addEventListener('click', () => {
    syncQty(parseInt(customQtyDisplay.textContent, 10) - 1);
  });
  shopifyPlus?.addEventListener('click', () => {
    setTimeout(() => syncQty(parseInt(shopifyQtyInput.value, 10)), 10);
  });
  shopifyMinus?.addEventListener('click', () => {
    setTimeout(() => syncQty(parseInt(shopifyQtyInput.value, 10)), 10);
  });
  shopifyQtyInput?.addEventListener('input', () => {
    let v = parseInt(shopifyQtyInput.value, 10);
    syncQty(isNaN(v) || v < 1 ? 1 : v);
  });

  function resetQtyAfterATC() {
    syncQty(1);
  }

  customATC?.addEventListener('click', () => {
    shopifyATC?.click();
    resetQtyAfterATC();
  });
  shopifyATC?.addEventListener('click', () => {
    setTimeout(resetQtyAfterATC, 200);
  });

  const priceEl = document.getElementById('block-price');
  const compareEl = document.getElementById('block-price-compare-at');
  const saveEl = document.getElementById('saveValue');

  function updateCustomPrice() {
    const priceSection = customCard.querySelector('.cw-price-section');
    if (!priceSection || !priceEl) return;
    priceSection.innerHTML = '';
    const saleSpan = document.createElement('span');
    saleSpan.className = 'cw-sale-price';
    saleSpan.textContent = priceEl.textContent.trim();
    priceSection.appendChild(saleSpan);
    const compText = compareEl?.textContent.trim();
    if (compText) {
      const origSpan = document.createElement('span');
      origSpan.className = 'cw-original-price';
      origSpan.textContent = compText;
      priceSection.appendChild(origSpan);
    }
    const saveText = saveEl?.textContent.trim();
    if (saveText) {
      const saveSpan = document.createElement('span');
      saveSpan.className = 'cw-discount';
      saveSpan.textContent = saveText;
      priceSection.appendChild(saveSpan);
    }
  }

  const priceContainer = document.getElementById('productFormPrice');
  if (priceContainer) {
    const priceObserver = new MutationObserver(() => updateCustomPrice());
    priceObserver.observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  updateCustomPrice();
  syncQty(parseInt(shopifyQtyInput?.value || '1', 10));
});
